export enum OPAStatusDesc {
  Pending = 'Pending',
  Authorised = 'Authorised',
  NotAuthorised = 'Not Authorised',
}